import React from 'react';

import { RealtorRatingTableTh } from '../RealtorRatingTableTh';
import {
  ERealtorRatingTableColumns,
  RealtorRatingTableColumnLabels,
  RealtorRatingTableSortableColumns,
} from '../../../constants';
import { ESortOrder } from '../../../types/sortOrder';
import * as s from './RealtorRatingTableThead.css';

interface IRealtorRatingTableThead {
  onSort?(columnHeader: ERealtorRatingTableColumns, sortOrder: ESortOrder): void;
  sortOrdering?: ERealtorRatingTableColumns;
  sortOrderingType?: ESortOrder;
}

/**
 * Заголовок таблицы рейтинга риелторов
 */
export const RealtorRatingTableThead = ({ sortOrdering, sortOrderingType, onSort }: IRealtorRatingTableThead) => {
  return (
    <thead>
      <tr>
        <th colSpan={3} />
        <th colSpan={2} className={s['th']}>
          <span>Советы</span>
        </th>
        <th colSpan={2} className={s['th']}>
          <span>Блоги</span>
        </th>
        <th colSpan={2} className={s['th']}>
          <span>Отзывы о ЖК</span>
        </th>
      </tr>

      <tr>
        {Object.entries(RealtorRatingTableColumnLabels).map(([key, value]) =>
          value ? (
            <RealtorRatingTableTh
              key={`th-${key}`}
              label={value}
              isSorted={sortOrdering === key}
              sortOrder={sortOrderingType}
              onClick={
                onSort && RealtorRatingTableSortableColumns[key as ERealtorRatingTableColumns]
                  ? sortOrder => onSort(key as ERealtorRatingTableColumns, sortOrder)
                  : undefined
              }
            />
          ) : (
            <th key={`th-${key}`} />
          ),
        )}
      </tr>
    </thead>
  );
};
